export default __webpack_public_path__ + "images/onboarding/class-mode-f9a27211b6dad94b8cef482263cbf910.png";